// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'caret-right';

export const Component = () => <path d='M8 4h2.75l6.5 8.5-6.5 8.5H8l6.5-8.5z' />;

export const viewBox = '0 0 25 25';
